import styled from 'styled-components';

import TextInputField from 'components/inputs/TextInputField';
import { Text2 } from 'components/typography/Texts';
import { LoadingIndicator } from 'components/ui-elements/LoadingIndicator';

const LoadingContainer = styled.div`
  flex: 1;
  margin: 0 24px;
`;

const StyledInput = styled(TextInputField)`
  flex: 1;
  height: 45px;
  border-radius: 5px;
  margin: 0 24px;
`;

const ValueText = styled(Text2)`
  flex: 1;
  margin: 0 24px;
  word-break: break-word;
`;

interface ContentSectionProps {
  isLoading: boolean;
  isEditing: boolean;
  inputValue: string;
  onChange: (value: string) => void;
  fieldType: string;
}

export const ContentSection = ({ isLoading, isEditing, inputValue, onChange, fieldType }: ContentSectionProps) => {
  if (isLoading) {
    return (
      <LoadingContainer>
        <LoadingIndicator />
      </LoadingContainer>
    );
  }

  return isEditing ? (
    <StyledInput testId={`${fieldType}-input`} value={inputValue} onChange={e => onChange(e)} />
  ) : (
    <ValueText data-testid={`${fieldType}-value`}>{inputValue}</ValueText>
  );
};
